<template>

  <div class="elevation-2 search-box white" v-if="searching">
    <v-toolbar flat="flat">
      <v-toolbar-title class="search-title">Search</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon class="search-bt"
              title="Hide the search"
              @click="closeSearch">mdi-magnify-close</v-icon>
    </v-toolbar>
    <v-container fluid="fluid" grid-list-md="grid-list-md">
      <v-layout class="my-3" row="row" wrap="wrap">

        <!-- NAME -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-4">
          <v-text-field class="field"
                        v-model="searchParams.name"
                        label="Name"
                        placeholder="Name"></v-text-field>
        </v-flex>

        <!-- CLUB -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWClubSelector ref="clubSelector"
                           :currentClubID="searchParams.clubID"
                           :label="'Club'"
                           @clubSelected="clubSelected"/>
        </v-flex>

        <!-- SPORT -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <SportSelector ref="sportSelector"
                         :currentSportIDs="searchParams.sportID"
                         @sportSelected="sportSelected"/>
        </v-flex>

        <!-- FEDERATION -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <FederationSelector ref="federationSelector"
                              :currentFederationID="searchParams.federationID"
                              :sportID="searchParams.sportID"
                              @federationSelected="federationSelected"/>
        </v-flex>

        <!-- AGE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <CategoryAgeSelector ref="categoryAgeSelector"
                               :currentCategoryAge="searchParams.categoryAge"
                               :federationID="searchParams.federationID"
                               :disabledText="'Please select a federation first'"
                               @categoryAgeSelected="categoryAgeSelected"/>
        </v-flex>

        <!-- GENDER -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <CategoryGenderSelector ref="categoryGenderSelector"
                               :currentCategoryGender="searchParams.categoryGender"
                               :federationID="searchParams.federationID"
                                  :disabledText="'Please select a federation first'"
                               @categoryGenderSelected="categoryGenderSelected"/>
        </v-flex>

      </v-layout>
      <v-layout row="row" wrap="wrap">
        <v-spacer></v-spacer>
        <v-btn class="search-action" :small="true" color="primary" flat="flat" @click.native="clearSearch">Clear</v-btn>
        <v-btn class="search-action" :small="true" color="primary" @click.native="search">Search</v-btn>
      </v-layout>
    </v-container>
  </div>

</template>

<script>

import SportSelector from '../common/SportSelector.vue'
import FederationSelector from '../common/FederationSelector.vue'
import NEWClubSelector from '../common/NEWClubSelector'
import CategoryAgeSelector from '../common/CategoryAgeSelector.vue'
import CategoryGenderSelector from '../common/CategoryGenderSelector.vue'

export default {
  name: 'Search',
  components: {
    SportSelector,
    FederationSelector,
    NEWClubSelector,
    CategoryAgeSelector,
    CategoryGenderSelector
  },
  props: ['searching'],
  data () {
    return {
      searchParams: {
        name: '',
        sportID: '',
        federationID: '',
        clubID: '',
        categoryAge: '',
        categoryGender: ''
      },

      clearSportSelector: Boolean
    }
  },
  methods: {
    search () {
      this.$emit('search', this.searchParams)
    },

    clearSearch () {
      this.$refs.clubSelector.clear()
      this.$refs.sportSelector.clear()
      this.$refs.federationSelector.clear()
      this.$refs.categoryAgeSelector.clear()
      this.$refs.categoryGenderSelector.clear()

      this.searchParams = {
        name: '',
        clubID: '',
        sportID: '',
        federationID: '',
        categoryAge: '',
        categoryGender: ''
      }
      this.$emit('clearSearch')
    },

    closeSearch () {
      this.$emit('closeSearch')
    },

    clubSelected (clubid) {
      this.searchParams.clubID = clubid
    },
    sportSelected (sportid) {
      this.searchParams.sportID = sportid
    },
    federationSelected (federationid) {
      this.searchParams.federationID = federationid
    },
    categoryAgeSelected (categoryage) {
      this.searchParams.categoryAge = categoryage
    },
    categoryGenderSelected (categorygender) {
      this.searchParams.categoryGender = categorygender
    }
  }
}

</script>

<style lang="scss" scoped>

.search-box {
  margin-bottom: 30px;
}

.search-title {
  font-size: 1rem;
  font-weight: 700;
}

.field {
  margin: 0 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/teams/Search.vue